(() => {
  "use strict";

  angular
    .module("uwAgenda.login")
    .controller("LinkCorilusPassportController", [
      "AppConfig",
      "HelperService",
      "AuthenticationService",
      "SharedAgendaService",
      "Alert",
      "WebsocketService",
      "ProgramInfoService",
      "AdministrationService",
      "ContactInfoService",
      "ViewsService",
      "CallsService",
      "StartPageEnum",
      "$state",
      "$translate",
      "$rootScope",
      "$filter",
      "UserContactinfoType",
    function (
      AppConfig,
      HelperService,
      AuthenticationService,
      SharedAgendaService,
      Alert,
      WebsocketService,
      ProgramInfoService,
      AdministrationService,
      ContactInfoService,
      ViewsService,
      CallsService,
      StartPageEnum,
      $state,
      $translate,
      $rootScope,
      $filter,
      UserContactinfoType
    ) {
      const vm = this;
      
      vm.step = 1;
      vm.confirmChecked = false;

      const _corilusData = JSON.parse(sessionStorage.getItem('temporaryCorilusLinkingData'));
      vm.accountName = _corilusData ? (_corilusData.userName || _corilusData.username || '') : '';
      
      vm.setStep = function (x) {
        vm.step = x;
        vm.confirmChecked = false;
      }
      
      vm.linkCorilusPassportIdClickEvent = function () {
        const clientId = `${AppConfig.clientId}`;
        const redirectUri = encodeURIComponent(`${AppConfig.redirectUri}`);
        const authUrl = AppConfig.authUrl;

        HelperService.GenerateRedirectionUrl(authUrl, clientId, redirectUri, "id_token");
      };
      
      vm.skipLinking = function () {

        const temporaryCorilusLinkingData = retrieveCorilusPassportLinkerDataFromSessionStorageAndClear();
        AuthenticationService.setAuthenticationHeader(temporaryCorilusLinkingData.api_token);
        
        AuthenticationService
          .swapToken()
          .then(function (loggedInUser) {

            SharedAgendaService.setLoggedInUserData({
              username: loggedInUser.userName,
              firstName: loggedInUser.firstName,
              lastName: loggedInUser.lastName,
              id: loggedInUser.id,
              roles: loggedInUser.roles.split(","),
              hasAgendaAccess: loggedInUser.hasAgendaAccess,
              licenceId: loggedInUser.licenceId,
            });

            AuthenticationService.saveRolesOfLoggedInUserInRootScope();
            AuthenticationService.setAuthenticationHeader(loggedInUser.api_token);

            connectAndOpenAgendas(loggedInUser);
          })
      }


      function retrieveCorilusPassportLinkerDataFromSessionStorageAndClear() {
        const data = JSON.parse(sessionStorage.getItem('temporaryCorilusLinkingData'));
        sessionStorage.removeItem('temporaryCorilusLinkingData');
        return data;
      }

      function connectAndOpenAgendas(loggedInUser) {
        // message
        Alert.success($translate.instant('hello_login') + ' ' + loggedInUser.firstName);
        // Websocket connection
        WebsocketService.connect(
          $rootScope.isRingfoon,
          loggedInUser.webSocketServer
        );

        var startPage = loggedInUser.startPage;

        // register program info screen
        ProgramInfoService.registerWebsocket();

        SharedAgendaService.loadAgendas().then(function (result) {
          // register WebSocket
          SharedAgendaService.registerWebsocket();

          //// helper service data
          // contact-info-types
          AdministrationService.contactinfotypes().then(function (result) {
            ContactInfoService.data.contactinfotypes = [];
            // make right type object
            var i = 0;
            var len = result.length;
            for (i = 0; i < len; i++) {
              var cit = new UserContactinfoType();
              cit.extend(result[i]);
              // add
              ContactInfoService.data.contactinfotypes.push(cit);
            } // for
          });

          // phonemasks
          AdministrationService.phonemasks().then(function (result) {
            HelperService.data.phonemasks = result;
          });

          // countries
          AdministrationService.countries().then(function (result) {
            HelperService.data.countries = result;
            HelperService.data.countriesWithCallingCodes = $filter(
              "filter"
            )(result, {callingCode: ""});
          });

          // load all views for the current user, 
          // if the current user is an operator: load the current agenda owner's views 
          var viewOwnerId = $rootScope.isRingfoon
            ? SharedAgendaService.currentUser().id
            : loggedInUser.id;

          ViewsService.getViewsForOwner(viewOwnerId)
            .then(function () {
              // do we need to load user-data for ringfoon info panel ?
              if ($rootScope.isRingfoon) {
                // register websocket for incoming calls
                CallsService.registerWebsocket();

                // ringfoon info -> user data of selected user/owner is required
                SharedAgendaService.loadOwner(
                  SharedAgendaService.currentUser().id
                ).then(function (result) {
                  // go to main page
                  showView(startPage);
                });
              } // if
              else {
                // go to main page
                showView(startPage);
              } // else
            });
        });

        function showView(startPage) {
          // get user's startpage if he has one selected, otherwise use default value
          if (typeof startPage === "undefined" || startPage === null) {
            startPage = StartPageEnum.AgendaDay.value;
          }

          // check if user has rights to access the saved startpage - if not, redirect him to a default start page he is allowed to access
          // Superadmin, Ringfoon operator admin, Main user and Subuser admin can access all pages
          if (
            !$rootScope.isMainuser &&
            !$rootScope.isRingfoonOperatorAdmin &&
            !$rootScope.isRingfoonAdmin &&
            !$rootScope.isSubuserAdmin
          ) {
            // Collegues can only access agenda-pages
            if (
              $rootScope.isColleague &&
              startPage !== StartPageEnum.AgendaDay.value &&
              startPage !== StartPageEnum.AgendaWeek.value
            ) {
              startPage = StartPageEnum.AgendaDay.value;
            }
            // // user is a restricted user and cannot access the user or agendasettings pages
            // else if (startPage === StartPageEnum.User.value || startPage === StartPageEnum.AgendaSettings.value) {
            //     startPage = StartPageEnum.DayTask.value;
            // }
          }

          switch (startPage) {
            case StartPageEnum.UrgentTodo.value:
              $state.go("Home.Tasks", {isToDo: "true", all: false});
              break;
            case StartPageEnum.User.value:
              $state.go("Home.Users", {all: false});
              break;
            case StartPageEnum.AgendaDay.value:
              $state.go("Home.Agenda_Day", {today: true});
              break;
            case StartPageEnum.AgendaWeek.value:
              $state.go("Home.Agenda_Week");
              break;
            case StartPageEnum.AgendaSettings.value:
              $state.go("Home.Agendasettings.General");
              break;
          }
        }
      }
    }]);
})();
